import React, { lazy, Suspense } from "react";
import { LazyMotion, domAnimation, AnimatePresence } from "framer-motion";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Loader from "../components/Loader";
import ScrollToTop from "./ScrollToTop";

const MainDashboard = lazy(() => import("../pages/MainDashboard"));
const PreSelection = lazy(() => import("../pages/PreSelection"));
// Misc
const PageNotFound = lazy(() => import("../components/NoPageFound"));
const NotAuthorize = lazy(() => import("../components/NotAuthorize"));

const Routing = ({ language, changeLanguage }) => {
  return (
    <div>
      <Suspense fallback={<Loader minHeight={"80vh"} />}>
        <Router>
          <AnimatePresence>
            <LazyMotion features={domAnimation}>
              <ScrollToTop />
              <Routes>
                <Route
                  path="/"
                  element={
                    <MainDashboard
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/loginSelection/:type/:service/:id"
                  element={
                    <PreSelection
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                {/* Misc */}
                <Route path="/notAuthorized" element={<NotAuthorize />}></Route>
                <Route path="*" element={<PageNotFound />}></Route>
              </Routes>
            </LazyMotion>
          </AnimatePresence>
        </Router>
      </Suspense>
    </div>
  );
};

export default Routing;
